import axiosApiInstance from '@/services/api'

class HttpServiceClass {
	constructor({ axiosApiInstance }) {
		this.axios = axiosApiInstance
	}

	removeAuthorizationHeader(headers) {
		const headersToUpdate = headers || this.axios.defaults.headers
		delete headersToUpdate.common['Authorization']
	}

	setAuthorizationHeader(token, headers) {
		const headersToUpdate = headers || this.axios.defaults.headers
		headersToUpdate.common['Authorization'] = 'Bearer ' + token
	}
}

const HttpService = new HttpServiceClass({ axiosApiInstance })

export default HttpService
